import { VolumeDown, VolumeUp } from "@mui/icons-material";
import {
  Box,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Slider,
  Stack,
  TextField,
} from "@mui/material";
import { styles, TrackControlButton } from "./styles";
import { EFFECTS, INSTRUMENT_TYPES } from "./types";
import { Props } from "./types";
import { InstrumentTrackProperties, TrackType } from "../../../pages/DAW/types";

const TrackControls: React.FC<Props> = ({
  trackProperties,
  handleNameChange,
  handleInstrumentTypeChange,
  handlePanChange,
  handleMuteChange,
  handleSoloChange,
  handleVolumeChange,
  handleEffectChange,
  handleRemoveTrack,
  onNameFieldFocusChange,
}) => {

  const { id, name, type, volume, pan, mute, solo } =
    trackProperties;
    
  return (
    <div style={styles.trackControls}>
      <Stack spacing={0} direction="row" alignItems="left">
        <Stack spacing={0} direction="column" sx={{ width: "45%" }}>
          <InputLabel id="outlined-basic" sx={styles.label}>
            Name
          </InputLabel>
          <TextField
            id="outlined-basic"
            variant="outlined"
            value={name}
            onBlur={() => onNameFieldFocusChange(false)}
            onFocus={() => onNameFieldFocusChange(true)}
            onChange={(event) => handleNameChange(event)}
            sx={styles.nameField}
          />
          {type === TrackType.INSTRUMENT && (
            <>
              <InputLabel id="instrument-select-label" sx={styles.label}>
                Instrument
              </InputLabel>
              <Select
                labelId="instrument-select-label"
                id="instrument-select"
                value={
                  (trackProperties as InstrumentTrackProperties).instrument
                    ?.type
                }
                onChange={(event: SelectChangeEvent<string>) =>
                  handleInstrumentTypeChange!(event)
                }
                sx={styles.instrumentType}
                placeholder="Instrument"
                variant="outlined"
                onClose={() => {
                  setTimeout(() => {
                    const target = document.activeElement as HTMLDivElement;
                    target.blur();
                  }, 0);
                }}
              >
                {INSTRUMENT_TYPES.map((value) => (
                  <MenuItem
                    key={value}
                    value={value}
                    sx={styles.instrumentListItem}
                  >
                    {value === "sampler" ? "drum" : value}
                  </MenuItem>
                ))}
              </Select>
              <InputLabel id="instrument-select-label" sx={styles.label}>
                Effects
              </InputLabel>
              <Select
                labelId="instrument-select-label"
                id="instrument-select"
                multiple={true}
                value={
                  ((trackProperties as InstrumentTrackProperties).effects?.map(
                    (e) => e.type
                  ) ?? [""]) as any
                }
                onChange={(event: SelectChangeEvent<string>) =>
                  handleEffectChange!(event)
                }
                sx={{ ...styles.instrumentType }}
                placeholder="Instrument"
                variant="outlined"
                onClose={() => {
                  setTimeout(() => {
                    const target = document.activeElement as HTMLDivElement;
                    target.blur();
                  }, 0);
                }}
              >
                {EFFECTS.map((value) => (
                  <MenuItem
                    key={value}
                    value={value}
                    sx={styles.instrumentListItem}
                  >
                    {value}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        </Stack>
        <Stack spacing={3} direction="column" sx={{ width: "50%" }}>
          <Stack spacing={0} direction="column">
            <InputLabel id="volume-select-label" sx={styles.label}>
              Volume
            </InputLabel>
            <Box sx={{ width: "100%", marginBottom: "10px" }}>
              <Stack
                spacing={2}
                direction="row"
                sx={{ margin: "0px" }}
                alignItems="center"
              >
                <VolumeDown sx={styles.icons} />
                <Slider
                  aria-label="Volume"
                  value={volume ?? 0}
                  onChange={(_event: Event, newValue: number | number[]) =>
                    handleVolumeChange(newValue as number)
                  }
                  sx={{ color: "#28B6CB" }}
                  min={0}
                  max={30}
                />
                <VolumeUp sx={styles.icons} />
              </Stack>
            </Box>
          </Stack>
          <Stack spacing={0} direction="column">
            <InputLabel id="volume-select-label" sx={styles.label}>
              Pan
            </InputLabel>
            <Box sx={{ width: "100%", marginBottom: "10px" }}>
              <Stack
                spacing={2}
                direction="row"
                sx={{ margin: "0px" }}
                alignItems="center"
              >
                <div style={styles.icons}>L</div>
                <Slider
                  aria-label="Volume"
                  value={pan ? pan * 100 : 0}
                  max={100}
                  min={-100}
                  onChange={(_event: Event, newValue: number | number[]) =>
                    handlePanChange(newValue as number)
                  }
                  sx={{ color: "#28B6CB" }}
                />
                <div style={styles.icons}>R</div>
              </Stack>
            </Box>
          </Stack>
          <Stack
            spacing={4}
            direction="row"
            sx={{
              width: "100%",
              justifyContent: "center",
            }}
            alignItems="center"
          >
            <TrackControlButton
              variant="contained"
              clicked={mute}
              onClick={() => handleMuteChange()}
            >
              M
            </TrackControlButton>
            <TrackControlButton
              variant="contained"
              clicked={solo}
              onClick={() => handleSoloChange()}
            >
              S
            </TrackControlButton>
            <TrackControlButton
              variant="contained"
              sx={{
                backgroundColor: "red",
                "&:hover": { backgroundColor: "red" },
              }}
              onClick={() => handleRemoveTrack(id)}
            >
              X
            </TrackControlButton>
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
};

export default TrackControls;
